var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Router } from 'react-router-dom';
import React from 'react';
import useHistory from '../hooks/useHistory';
export default function BrowserRouter(_a) {
    var children = _a.children, listeners = _a.listeners;
    var history = useHistory();
    var _b = __read(React.useState({
        action: history.action,
        location: history.location,
    }), 2), state = _b[0], setState = _b[1];
    React.useEffect(function () {
        listeners === null || listeners === void 0 ? void 0 : listeners.map(history.listen);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    React.useLayoutEffect(function () { return history.listen(setState); }, [history]);
    return (_jsx(Router, __assign({ action: state.action, location: state.location, navigator: history }, { children: children }), void 0));
}
//# sourceMappingURL=Router.js.map